import React from 'react';
import {hasRole} from '../utils/roles';

interface ProtectedRouteProps {
    user: any;
    /** Au moins UN de ces rôles/modules suffit à autoriser l'accès. */
    modules: string[];
    children: React.ReactNode;
}

/**
 * Bloque l'accès à une route si l'utilisateur n'a aucun des modules requis.
 * La sidebar masque déjà ces liens, mais sans ce garde-fou n'importe quel
 * utilisateur connecté pouvait accéder à une page en tapant son URL
 * directement — la sidebar n'est qu'un affichage, pas une protection.
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({user, modules, children}) => {
    if (!hasRole(user, ...modules)) {
        return (
            <div style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                minHeight: '60vh', gap: '12px', color: '#374151', textAlign: 'center', padding: '24px',
            }}>
                <i className="bi bi-shield-lock" style={{fontSize: '40px', color: '#ef4444'}}/>
                <h2 style={{margin: 0, fontSize: '18px'}}>Accès refusé</h2>
                <p style={{margin: 0, color: '#6b7280', maxWidth: '380px'}}>
                    Vous n'avez pas les droits nécessaires pour accéder à cette page.
                    Contactez un administrateur si vous pensez que c'est une erreur.
                </p>
            </div>
        );
    }
    return <>{children}</>;
};

export default ProtectedRoute;
